import * as Preact from 'preact';
import * as Hooks from 'preact/hooks';
import { styled } from '@mui/material';
import Typography, { TypographyProps } from '@mui/material/Typography';
import Box from '@mui/material/Box';

import { getLeadTime } from '../data/leadTime';
import { Product } from '../data/product';

import { CtaButtonCombo, sizing } from '@dora/components';

const TypographyPrimaryDark = styled(Typography)<TypographyProps>(({ theme }) => ({
    color: theme.palette.primary.dark,
}));

const TypographySecondaryLight = styled(Typography)<TypographyProps>(({ theme }) => ({
    color: theme.palette.secondary.light,
}));

export interface Props {
    onFinaliseClick: () => void;
    onArClick?: () => void;
    products: Array<Product>;
    totalPrice: string;
    platform: sizing.Platform;
}

export const Component = (p: Props) => {
    const leadTime = Hooks.useMemo(
        () => getLeadTime(p.products.map(pr => pr.leadTime)),
        [p.products],
    );

    return (
        <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            alignItems="end"
            padding="24px"
        >
            <Box
                sx={{
                    padding: '8px 0',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-end',
                    gap: '16px',
                }}
            >
                <Box>
                    <TypographyPrimaryDark variant="h6" noWrap={true} overflow="visible">
                        {leadTime !== 'In Stock' ? 'Arrives in: ' : ''}
                        <strong>{leadTime}</strong>
                    </TypographyPrimaryDark>
                </Box>
                <Box>
                    <TypographySecondaryLight
                        variant="body2"
                        sx={{ paddingBottom: '2px', color: '#676772' }}
                    >
                        Total Price:
                    </TypographySecondaryLight>
                    <Typography variant="h4">
                        <strong>{p.totalPrice}</strong>
                    </Typography>
                </Box>
            </Box>
            <Box width="186px">
                <CtaButtonCombo.Component
                    primaryOnClick={p.onFinaliseClick}
                    primaryCopy="Add to Cart"
                    secondaryOnClick={p.onArClick}
                    secondaryCopy="View in AR"
                    size={p.platform === sizing.Platform.MOBILE ? 'medium' : 'large'}
                    disabled={!p.products.length}
                    orientation="vertical"
                />
            </Box>
        </Box>
    );
};
